'use strict';

export const AUTH_LIBRARY_APP = 'library';


// WEBPACK FOOTER //
// ./config/auth.js